<span class="label">{{ 'lta.anchorPoint' | translate }}</span>
<div
        [allowed]="disabled"
        [class.disabled]="disabled"
        [lta-tooltip]="'lta.selectDriver' | translate"
        [position]="'down'"
        class="container"
>
    <span
            #wrapper
            [allowed]="isOverflowed && driverElementId"
            [class.focused]="isFocused(inputTarget) || isSelectOpen"
            [class.read-only]="hasTree$ | async"
            [lta-tooltip]="driverElementId | translate"
            [tooltipClasses]="['text-align-left', 'full-width']"
            class="wrapper"
            id="driver-element-select"
            position="down-left"
    >
        <input
                #inputTarget
                (input)="onInputValueChange($event.target.value)"
                [placeholder]="!driverElementId &&'lta.selectObjectToBind' | translate"
                [readOnly]="hasTree$ | async"
                [value]="driverElementId | translate"
        >
        <lta-svg-icon
                (click)="$event.stopPropagation(); removeSelection()"
                *ngIf="initialDriverElementId && driverElementId === initialDriverElementId"
                [lta-tooltip]="'lta.unlinkObject' | translate"
                [position]="'top'"
                class="icon"
                icon="unlink_red"
                size="20"
        ></lta-svg-icon>
        <lta-svg-icon
                (click)="createSelectDialog($event)"
                *ngIf="hasTree$ | async"
                [lta-tooltip]="'lta.openElementsTree' | translate"
                [position]="'top'"
                class="icon"
                icon="link_1"
                size="20"
        ></lta-svg-icon>
        <lta-svg-icon
                (click)="toggleMenu($event)"
                [class.open]="isSelectOpen"
                class="icon toggler"
                icon="down"
                size="20"
        ></lta-svg-icon>

    </span>
    <div
            [class.open]="isSelectOpen"
            class="select-menu"
    >
        <div
                (click)="selectItem($event, item)"
                *ngFor="let item of menuItems"
                [class.selected]="driverElementId === item"
                class="select-menu__item"
        >{{ item | translate }}
        </div>
    </div>

</div>
